// The win window's "play with people" line as a half split (audit 2026-11-01, section 9 #11; owner 2026-11-01): each
// browser falls once into group a (sees the line) or b (does not), so /admin can show whether it brings games online
// and what it does to solo play, which stands in for ad views: a New game reloads the page, a game online does not.
// No personal data: a letter in localStorage, sent with the play report. Not offline or on a partner's page; in the
// e2e tests only when a test sets the group, so the screenshots of the window keep their look.
import { env } from '../env';

export type WinLineGroup = 'a' | 'b';
const KEY = 'po-win-line';
const DAY_KEY = 'po-win-line-day';

export function winLineGroup(): WinLineGroup | null {
  if (env.appTarget !== '' && env.appTarget !== 'self') return null;
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === 'a' || stored === 'b') return stored;
    if (window.__E2E__) return null;
    const group: WinLineGroup = Math.random() < 0.5 ? 'a' : 'b';
    localStorage.setItem(KEY, group);
    return group;
  } catch {
    return null; // no storage: no line and no count, else one browser would count in both groups
  }
}

/** True once per UTC day: the group's browsers of the day, for a rate per browser. */
export function firstReportToday(): boolean {
  try {
    const today = new Date().toISOString().slice(0, 10);
    if (localStorage.getItem(DAY_KEY) === today) return false;
    localStorage.setItem(DAY_KEY, today);
    return true;
  } catch {
    return false;
  }
}
